export const LOGGER_QUERY_PARAMS = {
    DEBUG_SMART_TAG: 'debugSmartTag',
    DEBUG: 'debug'
};
export var LOGGER_ADAPTERS;
(function (LOGGER_ADAPTERS) {
    LOGGER_ADAPTERS["CONSOLE"] = "CONSOLE";
})(LOGGER_ADAPTERS || (LOGGER_ADAPTERS = {}));
export const LogLevels = {
    ERRORS_AND_INFO: 9,
    IMPORTANT: 5,
    VERBOSE: 1
};
export var LogMethods;
(function (LogMethods) {
    LogMethods["LOG"] = "log";
    LogMethods["INFO"] = "info";
    LogMethods["WARN"] = "warn";
    LogMethods["ERROR"] = "error";
    LogMethods["TABLE"] = "table";
    LogMethods["GROUP"] = "group";
    LogMethods["GROUP_COLLAPSED"] = "groupCollapsed";
    LogMethods["GROUP_END"] = "groupEnd";
})(LogMethods || (LogMethods = {}));
export const LogMethodsLevelsMap = {
    [LogMethods.LOG]: LogLevels.VERBOSE,
    [LogMethods.TABLE]: LogLevels.VERBOSE,
    [LogMethods.GROUP]: LogLevels.VERBOSE,
    [LogMethods.GROUP_COLLAPSED]: LogLevels.VERBOSE,
    [LogMethods.GROUP_END]: LogLevels.VERBOSE,
    [LogMethods.WARN]: LogLevels.IMPORTANT,
    [LogMethods.ERROR]: LogLevels.ERRORS_AND_INFO,
    [LogMethods.INFO]: LogLevels.ERRORS_AND_INFO
};
